import type { QueryKey, UseQueryOptions } from '@tanstack/vue-query'
import type { Applications } from '../types/Applications'
import { getError } from '@autobid/strapi-integration/utils/getError'
import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { onServerPrefetch } from 'vue'

export const USE_APPS_TANSTACK_KEY = ['applications']

export function useApps(options?: UseQueryOptions<Applications | null, unknown>) {
  const queryClient = useQueryClient()
  const { locale } = useI18n()
  const { $trpc } = useNuxtApp()

  const queryFn = async () => {
    try {
      return await $trpc.auctions.getApplications.query({ lang: locale.value })
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        showError({ statusCode: code, statusMessage: message })
      }

      return null
    }
  }

  const { suspense, ...rest } = useQuery(
    USE_APPS_TANSTACK_KEY as QueryKey,
    queryFn,
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )

  const prefetch = async () => {
    await queryClient.prefetchQuery({
      queryKey: USE_APPS_TANSTACK_KEY,
      queryFn,
    })
  }

  onServerPrefetch(async () => {
    if (options?.enabled === false)
      return
    await suspense()
  })

  return { suspense, prefetch, ...rest }
}
